module.exports = __webpack_public_path__ + "static/Samagra_Logo_Colored-77708ba01a0aee8d630d9eb4df12a35b.svg";